module.exports = __webpack_public_path__ + "static/11-6221895920b8bbcdabde0fa62fe326c0.png";